import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Input, Popconfirm, Row, Table } from 'antd';
import {
  QuestionCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import EditableFormRow from './EditableFormRow';
import EditableCell from './EditableCell';
import { NEW_ITEM_VALUE } from './Constant';
import Authorized from '../Authorization/Authorized';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const EditableTable = ({
  dataSource,
  retrieveAll,
  save,
  delete: delete1,
  cardTitle,
  loading,
  parentType,
  parentSelection,
}) => {
  const { t } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterValue, setFilterValue] = useState('');

  useEffect(() => {
    retrieveAll();
  }, []);

  const handleClearSelection = () => {
    setSelectedRowKeys([]);

    if (parentSelection) {
      parentSelection(0);
    }
  };

  const handleDelete = id => {
    delete1(id);
    handleClearSelection();
  };

  const handleMultipleDelete = () => {
    delete1(selectedRowKeys.join(','));
    handleClearSelection();
  };

  const handleAdd = () => {
    
    const newData = {
      value: NEW_ITEM_VALUE,
    };
    save(newData);
  };

  const handleSave = row => {
    
    setFilterValue('');

    save(row, row.id);
  };

  const onSelectChange = selected => {
    
    setSelectedRowKeys(selected);

    if (parentSelection) {
      parentSelection(selected[selected.length - 1]);
    }
  };

  const handleSearch = value => {
    setFilterValue(value);
    retrieveAll(value);
  };

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };
  const columnDefinition = [
    {
      title: t('common.name'),
      dataIndex: 'value',
      editable: true,
    },
    // {
    //   title: 'code',
    //   dataIndex: 'code',
    //   editable: false,
    // },
    {
      title: t('common.actions'),
      dataIndex: 'action',
      width: '20%',
      render: (text, record) => (
        // eslint-disable-next-line react/destructuring-assignment
        // TODO: what if number of elements in data source is less than 1 ? possible bug
        // this.props.dataSource.length >= 1 ? (<Popconfirm>) : null
        <Authorized asset={parentType} operation="write">
          <Popconfirm
            title={t('common.areYouSureToDelete')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => handleDelete(record.id)}
          >
            <Button icon={<DeleteOutlined />} />
          </Popconfirm>
        </Authorized>
      ),
    },
  ];

  const columns = columnDefinition.map(col => {
    if (!col.editable) {
      return {
        ...col,
        onCell: record => ({
          record,
          align: 'center',
        }),
      };
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        parentType,
      }),
    };
  });
  // rowSelection object indicates the need for row selection

  const hasSelected = selectedRowKeys.length > 0;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div>
      <Card
        title={cardTitle}
        bordered={false}
        loading={loading}
        extra={
          <div>
            <Authorized asset={parentType} operation="write">
              <Button
                icon={<DeleteOutlined />}
                onClick={handleMultipleDelete}
                disabled={!hasSelected}
                style={{ marginRight: 12 }}
              >
                {/* Delete */}
              </Button>
              <Button
                onClick={handleAdd}
                type="primary"
                icon={<PlusOutlined />}
                // style={{ marginBottom: 16 }}
              >
                {/* Add New */}
              </Button>
            </Authorized>
          </div>
        }
      >
        <Row style={{ paddingBottom: '8px' }}>
          <Search
            placeholder={t('common.search')}
            onSearch={value => handleSearch(value)}
            defaultValue={filterValue}
            allowClear
          />
        </Row>
        <Row justify="center" align="middle">
          <Col>
            <Table
              components={components}
              rowClassName={() => 'editable-row'}
              bordered={false}
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              rowKey={record => record.id}
              size="small"
              rowSelection={rowSelection}
              showHeader={false}
              scroll={{ y: 550 }}
            />
          </Col>
        </Row>
        <Authorized asset={parentType} operation="write">
          <Row type="flex" justify="center" style={{ paddingTop: '15px' }}>
            <Button
              onClick={handleAdd}
              type="primary"
              icon={<PlusOutlined />}
              // style={{ marginBottom: 16 }}
            >
              {t('common.add')}
            </Button>
          </Row>
        </Authorized>
      </Card>
    </div>
  );
};

EditableTable.propTypes = {
  dataSource: PropTypes.array,
  retrieveAll: PropTypes.func,
  save: PropTypes.func,
  delete: PropTypes.func,
  cardTitle: PropTypes.string,
  loading: PropTypes.bool,
  parentSelection: PropTypes.func,
  parentType: PropTypes.string,
};

export default EditableTable;
